import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./SettingsHub.css";
import { SmsTest } from "./SmsTest";
import { SignoffEmailTest } from "./SignoffEmailTest";

/**
 * Admin settings hub at /admin. Visible to administrator and super-admin
 * roles. Aggregates the existing role management and audit log surfaces
 * plus placeholders for upcoming site-appearance settings (tile photos,
 * headings, etc).
 */
export function AdminSettings() {
  const { t } = useTranslation();
  return (
    <div className="settings-hub">
      <h1 className="settings-hub__title">{t("adminHub.title")}</h1>
      <p className="settings-hub__subtitle">{t("adminHub.subtitle")}</p>
      <div className="settings-hub__grid">
        <Link to="/admin/users" className="settings-hub__card">
          <h2>{t("adminHub.cards.roles.title")}</h2>
          <p>{t("adminHub.cards.roles.desc")}</p>
        </Link>
        <Link to="/admin/audit" className="settings-hub__card">
          <h2>{t("adminHub.cards.audit.title")}</h2>
          <p>{t("adminHub.cards.audit.desc")}</p>
        </Link>
        <Link to="/admin/permissions" className="settings-hub__card">
          <h2>{t("adminHub.cards.permissions.title")}</h2>
          <p>{t("adminHub.cards.permissions.desc")}</p>
        </Link>
        <Link to="/admin/appearance" className="settings-hub__card">
          <h2>{t("adminHub.cards.appearance.title")}</h2>
          <p>{t("adminHub.cards.appearance.desc")}</p>
        </Link>
        <Link to="/admin/states" className="settings-hub__card">
          <h2>{t("adminHub.cards.factorStates.title")}</h2>
          <p>{t("adminHub.cards.factorStates.desc")}</p>
        </Link>
        <Link to="/admin/framework" className="settings-hub__card">
          <h2>{t("adminHub.cards.framework.title")}</h2>
          <p>{t("adminHub.cards.framework.desc")}</p>
        </Link>
      </div>
      <SmsTest />
      <SignoffEmailTest />
    </div>
  );
}

export default AdminSettings;
